import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'filter-2', 'Filter2', [["path",{"d":"M4 6h16"}],["path",{"d":"M6 12h12"}],["path",{"d":"M9 18h6"}]]);